import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { P } from '@vagusx/shared';
import { CampaignEditor } from '@/pages/campaigns/editor';
import { requireRoutePermission } from '@/lib/route-guard';

export const Route = createFileRoute('/_authenticated/campaigns/$id/edit')({
  beforeLoad: () => requireRoutePermission(P.OUTREACH_EDIT),
  component: EditCampaign,
});

function EditCampaign(): React.ReactElement {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  return (
    // Keyed on the campaign so moving straight from one to another remounts
    // the editor rather than publishing the first campaign's spec as the second.
    <CampaignEditor
      key={id}
      campaignId={id}
      onClose={() => void navigate({ to: '/campaigns/$id', params: { id } })}
      // A publish keeps the author in the editor to carry on; a launch shows
      // the campaign's page, where it now stands.
      onSaved={() => {}}
      onLaunched={() => void navigate({ to: '/campaigns/$id', params: { id } })}
    />
  );
}
